module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-flex",
      "position": "absolute",
      "right": "34px",
      "top": "0px"
    }
  }, [_c('mu-raised-button', {
    ref: "button",
    staticClass: "opaque",
    attrs: {
      "label-position": "before",
      "label": _vm.$t('message.graphPointsToggleTitle'),
      "icon": "arrow_drop_down",
      "disabled": _vm.isDisabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggle.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-popover', {
    attrs: {
      "scroller": _vm.scroller,
      "trigger": _vm.trigger,
      "open": _vm.open,
      "anchorOrigin": _vm.anchorOrigin,
      "targetOrigin": _vm.targetOrigin
    },
    on: {
      "close": _vm.handleClose
    }
  }, [_c('mu-list', {
    staticStyle: {
      "min-width": "180px"
    }
  }, [_c('mu-sub-header', [_vm._v(_vm._s(_vm.$t('message.graphPointsToggleTitle')) + "\n        "), _c('mu-icon-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "arrow_drop_up"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggle.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "disableRipple": "",
      "title": _vm.$t('message.graphPointToggleShowPoints')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleToggle('showPoints')
      }
    }
  }, [_c('mu-switch', {
    attrs: {
      "slot": "right"
    },
    slot: "right",
    model: {
      value: (_vm.showPoints),
      callback: function($$v) {
        _vm.showPoints = $$v
      },
      expression: "showPoints"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c36a4252","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Graph/graph-point-toggle.vue
// module id = 3287
// module chunks = 1